// src/themes/overrides/Paper.ts
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - PAPER ||============================== //

export default function Paper(theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none !important',
          backgroundColor: 'transparent !important',
          borderRadius: theme.shape.borderRadius,
          boxShadow: 'none !important',

          // Remover transparência quando sidebar estiver fechado
          '&.solid-menu': {
            backgroundColor: 'transparent',
            backdropFilter: 'none'
          }
        }
      }
    }
  };
}
